import { useTranslation } from "react-i18next"

import { ErrorIcon } from "@/components/icons"
import { ExecutionStatus } from "@/services/executions"

import { NoTradeState, TileStates, TradeState } from "../../tile.state"
import { OverlayBackgroundImage, OverlayBase, OverlayProps } from "./components"

export const FailureOverlay = ({
  tileState,
  ...props
}: OverlayProps & { tileState: TradeState | NoTradeState }) => {
  const { t } = useTranslation()
  return (
    <OverlayBase
      className="bg-error-primary text-error-primary"
      Icon={<ErrorIcon />}
      tradeId={tileState.trade?.tradeId}
      {...props}
    >
      <OverlayBackgroundImage className="bg-[url(@/components/icons/svg/errorIcon.svg)]">
        <p className="text-md-bold text-primary" role="alert">
          {(() => {
            if (tileState.status === TileStates.Timeout) {
              return t("liveRates.executionResponse.failure.timeout")
            }

            if (tileState.status === TileStates.CreditExceeded) {
              return t("liveRates.executionResponse.failure.creditExceeded")
            }

            if (
              tileState.status === TileStates.Finished &&
              tileState.trade.status === ExecutionStatus.Rejected
            ) {
              return t("liveRates.executionResponse.failure.rejected")
            }
          })()}
        </p>
      </OverlayBackgroundImage>
    </OverlayBase>
  )
}
